import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { Card, Form, FormProps, Modal, Select } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { setFilterUser } from "../../redux/slices/folderSlice.ts";
import { fetchAllUsers } from "../../redux/actions/usersActions.tsx";

interface Props {
  open: boolean;
  onClose: () => void;
}

type FormValues = {
  user: string;
};

const AssignedUserFilterComponent = forwardRef<any, Props>(
  ({ open, onClose }, ref) => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();

    const { userInfo } = useAppSelector((state) => state.auth);
    const { results: users } = useAppSelector((state) => state.user);
    const isAdmin = userInfo?.groups.includes("admin");
    const isAssistant = userInfo?.groups.includes("assistant");

    useImperativeHandle(ref, () => ({
      resetUserFilter: () => {
        form.resetFields();
      },
    }));

    useEffect(() => {
      onFetchUsers();
    }, [open]);

    const onFetchUsers = async () => {
      if (!open || (!isAdmin && !isAssistant)) return;
      await dispatch(fetchAllUsers("/accounts/users/?limit=1000"));
    };

    const onSubmit: FormProps<FormValues>["onFinish"] = ({ user }) => {
      const groups = users.find((u) => u.email === user)?.groups || [];
      const filterUser = {
        email: user,
        group:
          groups.length == 0 || groups.includes("cja") ? "cja" : "operations",
      };

      dispatch(setFilterUser(user ? filterUser : { email: "", group: "" }));
      onClose();
    };

    return (
      <div>
        <Modal
          title="Filtro por usuario"
          open={open}
          onCancel={onClose}
          onOk={() => form.submit()}
          okText="Filtrar"
          cancelText="Cancelar"
        >
          <Card>
            <div className="mb-2">
              Selecciona un usuario para filtrar sus expedientes
            </div>
            <Form onFinish={onSubmit} form={form}>
              <Form.Item<FormValues> name="user" style={{ marginBottom: 0 }}>
                <Select className="w-96" placeholder="Selecciona un usuario">
                  {users.map((user) => (
                    <Select.Option key={user.email} value={user.email}>
                      {user.name} - {user.email}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Card>
        </Modal>
      </div>
    );
  },
);

export const AssignedUserFilter = React.memo(AssignedUserFilterComponent);
